const personalizedCardArtUrl = "v1/credit/cards/personalized-card-art";
export {
  personalizedCardArtUrl
};
//# sourceMappingURL=endpoints.js.map
